module.exports = __webpack_public_path__ + "img/menu-sign-out-icon.fe12cd7a.svg";